const EMAIL_SPLIT_PATTERN = /[,;\n\r]+/

export function isValidEmailAddress (email) {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(String(email).trim())
}

export function parseEmailListInput (value) {
  if (value == null || value === '') return []
  if (Array.isArray(value)) {
    return value.map(entry => String(entry).trim()).filter(Boolean)
  }

  const str = String(value).trim()
  if (!str) return []

  if (str.startsWith('[')) {
    try {
      const parsed = JSON.parse(str)
      if (Array.isArray(parsed)) {
        return parsed.map(entry => String(entry).trim()).filter(Boolean)
      }
    } catch (e) {
      // fall through to delimiter parsing
    }
  }

  return str
    .split(EMAIL_SPLIT_PATTERN)
    .map(entry => entry.trim())
    .filter(Boolean)
}

export function formatEmailListForInput (value) {
  return parseEmailListInput(value).join(', ')
}

export function validateEmailListInput (value) {
  const entries = parseEmailListInput(value)
  if (!entries.length) return true
  return entries.every(entry => isValidEmailAddress(entry))
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Integrations/integrationEmailHelpers.js